import React from 'react';
import { Route, Switch } from 'react-router-dom';
import VocabulariesList from './VocabulariesList';
import VocabularyEdit from './VocabularyEdit';
import VocabularyUsage from './VocabularyUsage';
import RecordReplace from './RecordReplace';
var Vocabularies = function (_a) {
    var match = _a.match;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(match.path, "/new"), component: VocabularyEdit }),
        React.createElement(Route, { path: "".concat(match.path, "/:id/edit"), component: VocabularyEdit }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/usage/:type"), render: function () { return React.createElement(VocabularyUsage, { listPath: match.path }); } }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/:id/redirect"), render: function () { return React.createElement(RecordReplace, { mode: "redirect", sectionPath: match.path }); } }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/:id/merge"), render: function () { return React.createElement(RecordReplace, { mode: "merge", sectionPath: match.path }); } }),
        React.createElement(Route, { path: ["".concat(match.path, "/:id"), match.path], render: function (routeProps) { return (React.createElement(VocabulariesList, { match: match, selectedId: routeProps.match.params.id })); } })));
};
export default Vocabularies;
